exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mouse-cover-canvas { top: 177px !important; left: 480px !important;}\n", ""]);

// exports
